import Axios from 'axios';
import Vue from 'vue';

import store from "../store/store";
import store_user from "../store/modules/user";
import {refreshToken,saveRefreshtime,ToLogin} from "./api";
import config from './config'


// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
export const baseProUrl = process.env.BUILD_ENV == "build:pro" ? '' : 'http://logistics-wms.qa.aukeyit.com'
//PDA
//export const baseProUrl = process.env.BUILD_ENV == "build:pro" ? 'http://wms.shippingself.com' : 'http://logistics-wms.qa.aukeyit.com'
const baseDevUrl = window.origin


export let BaseUrl =( process.env.NODE_ENV == "development" ? baseDevUrl : baseProUrl)+'/wms';
export let BaseOpenUrl =( process.env.NODE_ENV == "development" ? baseDevUrl : baseProUrl)+'/openapi';
export let BaseApiUrl = BaseUrl+'/api';
export let BaseOpenApiUrl = BaseOpenUrl+'/api';
// 路由跳转使用
export let BaseRouterUrl = process.env.NODE_ENV == "development" ? baseDevUrl : baseProUrl;


// 请求延时
Axios.defaults.timeout = 120000

Axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(store_user.state.tokenExpire))
        
        if (store_user.state.token && (curTime < expiretime && store_user.state.tokenExpire)) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token

            config.headers.Authorization = "Bearer " + store_user.state.token;
        }

        saveRefreshtime();

        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
Axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {

            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });

            originalRequest._retry = true
            return null;
        }

        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            Vue.prototype.$message({
                                message: 'refreshToken success! loading data...',
                                type: 'success'
                            });

                            store.commit("saveToken", res.response.token);

                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                            store.commit("saveTokenExpire", expiredate);

                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                }

            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);

export const axios = Axios;